"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tableComponent = exports.TableComponent = void 0;
const app_1 = require("app");
const RenderTable_1 = require("./components/RenderTable");
const tableParser_1 = require("./helpers/tableParser");
class TableComponent extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.table-wrap';
    }
    BeforeInit() {
        this.tableData = tableParser_1.TableParser.ParseTable('.table');
        this.el.forEach((elem, index) => {
            if (elem.querySelectorAll('.table').length) {
                (0, RenderTable_1.RenderTable)(this.tableData[index], elem);
            }
        });
    }
}
exports.TableComponent = TableComponent;
exports.tableComponent = new TableComponent();
